// extracted by mini-css-extract-plugin
export var container = "styles-module--container--c470d";
export var content = "styles-module--content--e1566";
export var content__text = "styles-module--content__text--2b76f";
export var line = "styles-module--line--ce42e";